import {
  Column,
  Container,
  Icon,
  Row,
  Text
} from '@smu-chile/pkg-unimarc-components'
import { getGlobalStyle } from '@smu-chile/pkg-unimarc-components/helpers'
import { WrapTooltip, WrapTooltipProps } from './WrapTooltip'

export type CodeExpiredTooltipProps = WrapTooltipProps

export const CodeExpiredTooltip = (props: CodeExpiredTooltipProps) => {
  return (
    <WrapTooltip
      variant='error'
      {...props}
    >
      <Container>
        <Row
          alignItems='center'
          gap={8}
        >
          <Column maxWidth='max-content'>
            <Icon
              color={getGlobalStyle('--color-feedback-error-light')}
              customSize={20}
              name='InfoFill'
            />
          </Column>

          <Column margin='0 10px 0 0'>
            <Text
              color='black'
              display='block'
              fontSize='md'
              fontWeight='medium'
            >
              El código ha expirado. Solicita uno nuevo.
            </Text>
          </Column>
        </Row>
      </Container>
    </WrapTooltip>
  )
}
